<template>
    <USelect :ui="{
        item: 'data-disabled:line-through'
    }" placeholder="Pasirinkite" v-model="selectedOption" :items="items" class="w-48" />
</template>
<script setup lang="ts">
import type { ProductOptionValueWithAvailability } from '~/types';

const {
    options,
    selected,
} = defineProps<{
  options: ProductOptionValueWithAvailability[],
  selected?: number
}>()

const emit = defineEmits<{
  (e: 'selectOption', optionValueId: number): void
}>()

const items = computed(() => {
    return options.map((option) => ({
        label: option.name,
        value: option.id,
        disabled: !option.available
    }))
})

const selectedOption = ref<number | undefined>(selected);

watch(() => selected, (newValue) => {
    selectedOption.value = newValue;
});

watch(selectedOption, (newValue) => {
    if (newValue !== undefined) {
        emit('selectOption', newValue)
    }
});
</script>